import { lazy } from "react";

const lazyDefault = (loader) => lazy(loader);

const lazyNamed = (loader, name) =>
  lazy(async () => {
    const module = await loader();
    return { default: module[name] };
  });

export const Switcherlayout = lazyDefault(() => import("../components/switcherlayout"));

export const App = lazyDefault(() => import("../components/app"));
export const Custompages = lazyDefault(() => import("../components/custompages"));

export const Dashboard = lazyDefault(() => import("../components/Dashboard/Dashboard"));
export const Widgets = lazyDefault(() => import("../components/Widgets/Widgets"));

export const CardDesign = lazyDefault(
  () => import("../components/Components/CardDesign/CardDesign")
);

export const AllUsers = lazyDefault(() => import("../components/Scn-Components/Auth/AllUsers"));
export const CreateUser = lazyDefault(() => import("../components/Scn-Components/Auth/CreateUser"));

export const Application = lazyDefault(
  () => import("../components/Scn-WebComponents/Application/Application")
);
export const Password = lazyDefault(
  () => import("../components/Scn-WebComponents/Password/Password")
);
export const EnquiryLetter = lazyDefault(
  () => import("../components/Scn-WebComponents/EnquiryLetter/EnquiryLetter")
);
export const NewLetter = lazyDefault(
  () => import("../components/Scn-WebComponents/NewLetter/NewLetter")
);
export const NewLetterCJN = lazyDefault(
  () => import("../components/Scn-WebComponents/NewLetter/NewLetterCJN")
);
export const NewLetter2 = lazyDefault(
  () => import("../components/Scn-WebComponents/NewLetter/NewLetter2")
);
export const EditEnquiryLetter = lazyDefault(
  () => import("../components/Scn-WebComponents/EnquiryLetter/EnquiryLetterEdith")
);
export const Amount = lazyDefault(() => import("../components/Scn-Components/Payments/Amount.js"));

export const OathInstruments = lazyDefault(
  () => import("../components/Scn-WebComponents/OathInstrument/OathInstrument")
);
export const CertificationList = lazyDefault(
  () => import("../components/Scn-Components/Certification/CertificationList")
);
export const Certificate = lazyDefault(
  () => import("../components/Scn-Components/Certification/Certificate")
);
export const AwaitingCertificationList = lazyDefault(
  () => import("../components/Scn-Components/Certification/AwaitingCertification")
);
export const FinalStage = lazyDefault(
  () => import("../components/Scn-WebComponents/FinalStage/FinalStage")
);

export const StatusSearch = lazyDefault(
  () => import("../components/Scn-WebComponents/StatusSearch/StatusSearch")
);

export const GraduantsUpload = lazyDefault(
  () => import("../components/Scn-WebComponents/GraduantsUpload/graduantsUpload")
);
export const ToEnroll = lazyDefault(
  () => import("../components/Scn-WebComponents/ToEnroll/ToEnroll")
);
export const ContentScrollBar = lazyDefault(
  () => import("../components/Components/ContentScrollBar/ContentScrollBar")
);
export const Counters = lazyDefault(() => import("../components/Components/Counters/Counters"));
export const DefaultChat = lazyDefault(
  () => import("../components/Components/DefaultChat/DefaultChat")
);
export const FullCalendar = lazyDefault(
  () => import("../components/Components/FullCalendar/FullCalendar")
);
export const Loader = lazyDefault(() => import("../components/Components/Loaders/Loaders"));

export const Notifications = lazyDefault(
  () => import("../components/Components/Notifications/Notifications")
);
export const RangeSlider = lazyDefault(
  () => import("../components/Components/RangeSlider/RangeSlider")
);
export const Rating = lazyDefault(() => import("../components/Components/Rating/Rating"));
export const SweetAlerts = lazyDefault(
  () => import("../components/Components/SweetAlerts/SweetAlerts")
);
export const Timeline = lazyDefault(() => import("../components/Components/Timeline/Timeline"));
export const Treeview = lazyDefault(() => import("../components/Components/Treeview/Treeview"));

export const Alerts = lazyDefault(() => import("../components/Elements/Alerts/Alerts"));
export const AvatarRounded = lazyDefault(
  () => import("../components/Elements/AvatarRounded/AvatarRounded")
);
export const AvatarSquares = lazyDefault(
  () => import("../components/Elements/AvatarSquares/AvatarSquares")
);
export const AvatarRadius = lazyDefault(
  () => import("../components/Elements/AvatarRadius/AvatarRadius")
);
export const Badges = lazyDefault(() => import("../components/Elements/Badges/Badges"));
export const Buttons = lazyDefault(() => import("../components/Elements/Buttons/Buttons"));
export const Breadcrumbs = lazyDefault(
  () => import("../components/Elements/Breadcrumbs/Breadcrumbs")
);
export const Colors = lazyDefault(() => import("../components/Elements/Colors/Colors"));
export const DropDowns = lazyDefault(() => import("../components/Elements/DropDowns/DropDowns"));
export const List = lazyDefault(() => import("../components/Elements/List/List"));
export const Navigation = lazyDefault(() => import("../components/Elements/Navigation/Navigation"));
export const Paginations = lazyDefault(
  () => import("../components/Elements/Paginations/Paginations")
);
export const Panels = lazyDefault(() => import("../components/Elements/Panels/Panels"));
export const Tags = lazyDefault(() => import("../components/Elements/Tags/Tags"));
export const Thumbnails = lazyDefault(() => import("../components/Elements/Thumbnails/Thumbnails"));
export const Typography = lazyDefault(() => import("../components/Elements/Typography/Typography"));

export const Mediaobject = lazyDefault(
  () => import("../components/Advanced-Elements/Mediaobject/Mediaobject")
);
export const Accordions = lazyDefault(
  () => import("../components/Advanced-Elements/Accordion/Accordions")
);
export const Carousels = lazyDefault(
  () => import("../components/Advanced-Elements/Carousel/Carousels")
);
export const Charts = lazyDefault(() => import("../components/Advanced-Elements/Charts/Charts"));
export const Cryptocurrencies = lazyDefault(
  () => import("../components/Advanced-Elements/Crypto-currencies/Crypto-currencies")
);
export const Footer = lazyDefault(() => import("../components/Advanced-Elements/Footers/Footers"));
export const Header = lazyDefault(() => import("../components/Advanced-Elements/Headers/Headers"));
export const Modal = lazyDefault(() => import("../components/Advanced-Elements/Modal/Modal"));
export const Progress = lazyDefault(
  () => import("../components/Advanced-Elements/Progress/Progress")
);
export const Search = lazyDefault(() => import("../components/Advanced-Elements/Search/Search"));
export const Tabs = lazyDefault(() => import("../components/Advanced-Elements/Tabs/Tabs"));
export const UserList = lazyDefault(
  () => import("../components/Advanced-Elements/UserList/UserList")
);
export const TooltipandPopover = lazyDefault(
  () => import("../components/Advanced-Elements/TooltipandPopover/TooltipandPopover")
);

export const ChartJs = lazyDefault(() => import("../components/Charts/ChartJs/ChartJs"));
export const PieCharts = lazyDefault(() => import("../components/Charts/PieCharts/PieCharts"));
export const Echarts = lazyDefault(() => import("../components/Charts/Echarts/Echarts"));
export const Nvd3charts = lazyDefault(() => import("../components/Charts/Nvd3Charts/Nvd3charts"));

export const DefaultTables = lazyDefault(
  () => import("../components/Table/DefaultTables/DefaultTables")
);
export const DataTables = lazyDefault(() => import("../components/Table/DataTables/DataTables"));

export const FormAdvanced = lazyDefault(
  () => import("../components/Form/FormAdvanced/FormAdvanced")
);
export const FormEditor = lazyDefault(() => import("../components/Form/FormEditor/FormEditor"));
export const FormValidation = lazyDefault(
  () => import("../components/Form/FormValidation/FormValidation")
);
export const FormWizard = lazyDefault(() => import("../components/Form/FormWizard/FormWizard"));

export const FontAwesome = lazyDefault(
  () => import("../components/Icons/FontAwesomes/FontAwesomes")
);
export const MaterialDesignIcons = lazyDefault(
  () => import("../components/Icons/MaterialDesignIcons/MaterialDesignIcons")
);
export const SimpleLineIcons = lazyDefault(
  () => import("../components/Icons/SimplelineIcons/SimplelineIcons")
);
export const FeatherIcons = lazyDefault(
  () => import("../components/Icons/FeatherIcons/FeatherIcons")
);
export const IonicIcons = lazyDefault(() => import("../components/Icons/IonicIcons/IonicIcons"));
export const FlagIcons = lazyDefault(() => import("../components/Icons/FlagsIcons/FlagsIcons"));
export const Pe7Icons = lazyDefault(() => import("../components/Icons/Pe7Icons/Pe7Icons"));
export const ThemifyIcons = lazyDefault(
  () => import("../components/Icons/ThemifyIcons/ThemifyIcons")
);
export const TypiconsIcons = lazyDefault(
  () => import("../components/Icons/TypiconsIcons/TypiconsIcons")
);
export const WeatherIcons = lazyDefault(
  () => import("../components/Icons/WeatherIcons/WeatherIcons")
);

export const Profile = lazyDefault(() => import("../components/pages/Profile/Profile"));
export const EditProfile = lazyDefault(() => import("../components/pages/EditProfile/EditProfile"));
export const MailInbox = lazyDefault(() => import("../components/pages/MailInbox/MailInbox"));
export const MailCompose = lazyDefault(() => import("../components/pages/MailCompose/MailCompose"));
export const Gallery = lazyDefault(() => import("../components/pages/Gallery/Gallery"));
export const AboutCompany = lazyDefault(
  () => import("../components/pages/AboutCompany/AboutCompany")
);
export const Services = lazyDefault(() => import("../components/pages/Services/Services"));
export const FAQS = lazyDefault(() => import("../components/pages/FAQS/FAQS"));
export const Terms = lazyDefault(() => import("../components/pages/Terms/Terms"));
export const Invoice = lazyDefault(() => import("../components/pages/Invoice/Invoice"));
export const PricingTables = lazyDefault(
  () => import("../components/pages/PricingTables/PricingTables")
);
export const Empty = lazyDefault(() => import("../components/pages/Empty/Empty"));
export const UnderConstruction = lazyDefault(
  () => import("../components/pages/UnderConstruction/UnderConstruction")
);

export const Blog = lazyDefault(() => import("../components/pages/Blog/Blog/Blog"));
export const BlogDetails = lazyDefault(
  () => import("../components/pages/Blog/BlogDetails/BlogDetails")
);
export const BlogPost = lazyDefault(() => import("../components/pages/Blog/BlogPost/BlogPost"));

export const LeafletMaps = lazyDefault(() => import("../components/Maps/LeafletMaps/LeafletMaps"));
export const VectorMaps = lazyDefault(() => import("../components/Maps/VectorMaps/VectorMaps"));

export const Shop = lazyDefault(() => import("../components/pages/E-Commerce/Shop/Shop"));
export const Checkout = lazyDefault(
  () => import("../components/pages/E-Commerce/Checkout/Checkout")
);
export const ProductDetails = lazyDefault(
  () => import("../components/pages/E-Commerce/ProductDetails/ProductDetails")
);
export const ShoppingCarts = lazyDefault(
  () => import("../components/pages/E-Commerce/ShoppingCarts/ShoppingCarts")
);
export const Wishlist = lazyDefault(
  () => import("../components/pages/E-Commerce/Wishlist/Wishlist")
);

export const FileManager = lazyDefault(
  () => import("../components/pages/FileManager/FileManager/FileManager")
);
export const FileAttachments = lazyDefault(
  () => import("../components/pages/FileManager/FileAttachments/FileAttachments")
);
export const FileDetails = lazyDefault(
  () => import("../components/pages/FileManager/FileDetails/FileDetails")
);
export const FileManagerList = lazyDefault(
  () => import("../components/pages/FileManager/FileManagerList/FileManagerList")
);

export const Login = lazyDefault(() => import("../components/Scn-Components/Login/Login"));
export const OtpVerification = lazyDefault(
  () => import("../components/Scn-Components/Login/OtpVerification")
);
export const Register = lazyDefault(() => import("../components/CustomPages/Register/Register"));
export const ForgotPassword = lazyDefault(
  () => import("../components/Scn-Components/ForgotPassword/ForgotPassword")
);
export const ForgotRequest = lazyDefault(
  () => import("../components/Scn-Components/ForgotPassword/ForgotRequest")
);
export const PasswordReset = lazyDefault(
  () => import("../components/Scn-Components/ForgotPassword/PasswordReset")
);
export const CreateModule = lazyDefault(
  () => import("../components/Scn-Components/Module/CreateModule")
);
export const CreateTitle = lazyDefault(
  () => import("../components/Scn-Components/Title/CreateTitle")
);
export const CreateAmount = lazyDefault(
  () => import("../components/Scn-Components/PaymentAmount/CreateAmount")
);
export const GetChangeOfName = lazyDefault(
  () => import("../components/Scn-Components/ChangeOfName/GetChangeOfName")
);
export const GetRegisteredUsers = lazyDefault(
  () => import("../components/Scn-Components/RegisteredUsers/GetRegisteredUsers")
);
export const GetAllApprovedApplicants = lazyDefault(
  () => import("../components/Scn-Components/RegisteredUsers/GetAllApprovedApplicants")
);
export const GetSignedEnquiryLetters = lazyDefault(
  () => import("../components/Scn-Components/RegisteredUsers/GetSignedEnquiryLetters")
);
export const GetAllApprovedRecommendations = lazyDefault(
  () => import("../components/Scn-Components/RegisteredUsers/GetAllApprovedRecommendations")
);
export const GetRecommendationLetter = lazyDefault(
  () => import("../components/Scn-Components/RegisteredUsers/GetRecommendationLetter")
);
export const GetOathInstruments = lazyDefault(
  () => import("../components/Scn-Components/RegisteredUsers/GetOathInstruments")
);
export const GetApprovedRecommendations = lazyDefault(
  () => import("../components/Scn-Components/RegisteredUsers/GetApprovedRecommendations")
);
export const GetRegisteredUsersDRC = lazyDefault(
  () => import("../components/Scn-Components/RegisteredUsers/GetRegisteredUsersDCR")
);
export const GetRegisteredUsersStaff = lazyDefault(
  () => import("../components/Scn-Components/RegisteredUsers/GetRegisteredUsersStaff")
);
export const GetActedRecordsByCjn = lazyDefault(
  () => import("../components/Scn-Components/ActedRecords/GetActedRecordsByCjn.js")
);
export const GetSignedOathInstruments = lazyDefault(
  () => import("../components/Scn-Components/RegisteredUsers/GetSignedOathInstruments.js")
);
export const GetAwaitingSignOathInstruments = lazyDefault(
  () => import("../components/Scn-Components/RegisteredUsers/GetAwaitingSignOathInstruments.js")
);
export const GetSwornInApplications = lazyDefault(
  () => import("../components/Scn-Components/RegisteredUsers/GetSwornInApplications.js")
);
export const GetCjnLetters = lazyDefault(
  () => import("../components/Scn-Components/RegisteredUsers/GetCjnLetters")
);
export const GetApprovedApplications = lazyDefault(
  () => import("../components/Scn-Components/RegisteredUsers/GetApprovedApplications")
);
export const GetCompletedApplications = lazyDefault(
  () => import("../components/Scn-Components/RegisteredUsers/GetCompletedApplications")
);

export const GetOathLists = lazyDefault(
  () => import("../components/Scn-Components/OathLists/GetOathLists")
);
export const SingleOath = lazyDefault(
  () => import("../components/Scn-Components/OathLists/SingleOath")
);
export const GetLetters = lazyDefault(
  () => import("../components/Scn-Components/Letters/GetLetters")
);
export const StateResponseList = lazyDefault(
  () => import("../components/Scn-Components/Letters/StateResponse.js")
);
export const JudgeResponseList = lazyDefault(
  () => import("../components/Scn-Components/Letters/JudgeResponse.js")
);

export const OathList = lazyDefault(() => import("../components/Scn-Components/OathList/OathList"));
export const SingleOathList = lazyDefault(
  () => import("../components/Scn-Components/OathList/SingleOath")
);
export const EditChangeOfName = lazyDefault(
  () => import("../components/Scn-Components/ChangeOfName/EditChangeOfName")
);
export const GetSingleEnrollment = lazyDefault(
  () => import("../components/Scn-Components/Enrollment/SingleEnrolledUser")
);
export const EditEnrollment = lazyDefault(
  () => import("../components/Scn-Components/Enrollment/EditEnrolledUser")
);
export const GetEnrollement = lazyDefault(
  () => import("../components/Scn-Components/Enrollment/GetEnrollment")
);
export const EnrolledUserList = lazyDefault(
  () => import("../components/Scn-Components/EnrolledUsers/EnrolledUserList")
);
export const InitialApplication = lazyDefault(
  () => import("../components/Scn-Components/Application/Application")
);
export const SingleConfirmation = lazyDefault(
  () => import("../components/Scn-Components/Application/SingleConfirmation")
);
export const ApplicationConfirmation = lazyDefault(
  () => import("../components/Scn-Components/Application/ConfirmApplication")
);
export const ApplicationStatus = lazyDefault(
  () => import("../components/Scn-Components/Application/ApplicationStatus")
);

export const CreateRole = lazyDefault(
  () => import("../components/Scn-Components/Module/CreateRole")
);
export const AssignUserToRole = lazyDefault(
  () => import("../components/Scn-Components/Module/AssignUserToRole")
);
export const AssignModuleToRole = lazyDefault(
  () => import("../components/Scn-Components/Module/AssignModuleToRole")
);
export const CreateSubmodule = lazyDefault(
  () => import("../components/Scn-Components/Module/CreateSubmodule")
);
export const LockScreen = lazyDefault(
  () => import("../components/CustomPages/LockScreen/LockScreen")
);
export const EnrollmentConfirmation = lazyDefault(
  () => import("../components/Scn-WebComponents/ToEnroll/EnrollmentConfirmation.js")
);

export const Errorpage400 = lazyDefault(
  () => import("../components/ErrorPages/ErrorPages/400/400")
);
export const Errorpage401 = lazyDefault(
  () => import("../components/ErrorPages/ErrorPages/401/401")
);
export const Errorpage403 = lazyDefault(
  () => import("../components/ErrorPages/ErrorPages/403/403")
);
export const Errorpage500 = lazyDefault(
  () => import("../components/ErrorPages/ErrorPages/500/500")
);
export const Errorpage503 = lazyDefault(
  () => import("../components/ErrorPages/ErrorPages/503/503")
);

// Web components (public-facing pages)
export const Home = lazyDefault(() => import("../components/Scn-WebComponents/Home/Home"));
export const About = lazyDefault(() => import("../components/Scn-WebComponents/About/About"));
export const Contact = lazyDefault(() => import("../components/Scn-WebComponents/Contact/Contact"));
export const VerifyLetter = lazyDefault(
  () => import("../components/Scn-WebComponents/VerifyLetter/VerifyLetter.jsx")
);
export const VerifyRecommendation = lazyDefault(
  () => import("../components/Scn-WebComponents/VerifyRecommendation/VerifyRecommendation.jsx")
);
export const UserProfile = lazyDefault(
  () => import("../components/Scn-WebComponents/Profile/Profile")
);
export const ChangeOfName = lazyDefault(
  () => import("../components/Scn-WebComponents/ChangeOfName/ChangeOfName")
);
export const ChiefRegistrars = lazyDefault(
  () => import("../components/Scn-Components/Registra/ChiefRegistrars")
);
export const CreateChiefRegistrar = lazyDefault(
  () => import("../components/Scn-Components/Registra/CreateChiefRegistrar")
);
export const DocumentTypes = lazyDefault(
  () => import("../components/Scn-Components/DocumentTypes/Document")
);
export const RegistrarApproveEnrolled = lazyDefault(
  () => import("../components/Scn-Components/Enrollment/RegistrarApproveEnrolled")
);
export const PendingLettersList = lazyDefault(
  () => import("../components/Scn-Components/Letters/PendingLetters")
);
export const SignedLettersList = lazyDefault(
  () => import("../components/Scn-Components/Letters/SignedLetters")
);
export const UploadLetter = lazyDefault(
  () => import("../components/Scn-Components/Letters/UploadRecommendationLetter")
);
export const UploadOathInstrument = lazyDefault(
  () => import("../components/Scn-Components/Letters/UploadOathInstrument")
);
export const SinglePendingLetter = lazyDefault(
  () => import("../components/Scn-Components/Letters/SinglePendingLetter")
);
export const MyProfile = lazyDefault(() => import("../components/Scn-Components/Auth/MyProfile"));
export const RegistrarApprovalList = lazyDefault(
  () => import("../components/Scn-Components/Enrollment/RegistrarApprovalList")
);
export const ViewProfile = lazyDefault(
  () => import("../components/Scn-Components/RegisteredUsers/ViewProfile")
);
export const ViewProfileStaff = lazyDefault(
  () => import("../components/Scn-Components/RegisteredUsers/ViewProfileStaff")
);
export const ViewProfileDCR = lazyDefault(
  () => import("../components/Scn-Components/RegisteredUsers/ViewProfileDCR.jsx")
);
export const ViewSingleActedRecordByCj = lazyDefault(
  () => import("../components/Scn-Components/ActedRecords/ViewSingleActedRecordByCj.jsx")
);
export const AuditComments = lazyDefault(
  () => import("../components/Scn-Components/RegisteredUsers/AuditComments")
);
export const SingleStateResponse = lazyDefault(
  () => import("../components/Scn-Components/RegisteredUsers/SingleStateResponse.jsx")
);
export const SingleStateApproval = lazyDefault(
  () => import("../components/Scn-Components/RegisteredUsers/SingleStateApproval.jsx")
);
export const SingleJudgeRecommendation = lazyDefault(
  () => import("../components/Scn-Components/RegisteredUsers/SingleJudgeRecommendation.jsx")
);
export const VerfiedApplications = lazyDefault(
  () => import("../components/Scn-Components/Application/VerifiedApplications")
);
export const AssignChiefJudge = lazyDefault(
  () => import("../components/Scn-Components/ChiefJudge/AssignChiefJudge")
);
export const CreateJudge = lazyDefault(
  () => import("../components/Scn-Components/ChiefJudge/CreateJudge")
);
export const InitiatePayment = lazyDefault(
  () => import("../components/Scn-WebComponents/InitiatePayment/InitiatePayment.js")
);
export const VerifyPracticeFee = lazyNamed(
  () => import("../components/Scn-Components/Application/VerifyPracticeFee.js"),
  "VerifyPracticeFee"
);
export const ResendFailedPayment = lazyNamed(
  () => import("../components/Scn-Components/Application/ResendFailedPayment.js"),
  "ResendFailedPayment"
);
export const VerifiedPracticeFeePage = lazyNamed(
  () => import("../components/Scn-Components/Application/VerifiedPracticeFeePage.js"),
  "VerifiedPracticeFeePage"
);
export const GetActedRecordsByCj = lazyDefault(
  () => import("../components/Scn-Components/ActedRecords/GetActedRecordsByCj.js")
);
export const GetCompletedApplicants = lazyDefault(
  () => import("../components/Scn-Components/RegisteredUsers/GetCompletedApplicants.js")
);
export const DispatchLetter = lazyDefault(
  () => import("../components/Scn-Components/DispatchLetter/DispatchLetters.js")
);
export const PaymentSuccess = lazyDefault(
  () => import("../components/Scn-WebComponents/PaymentSuccess/PaymentSuccess.js")
);
export const VerifiedApplicationsByState = lazyDefault(
  () => import("../components/Scn-Components/RegisteredUsers/VerifiedApplicationsByState.js")
);
export const EnquiryLetterByState = lazyDefault(
  () => import("../components/Scn-WebComponents/EnquiryLetterByState/EnquiryLetterByState.jsx")
);
export const VerifiedApplicationsByStateCR = lazyDefault(
  () => import("../components/Scn-Components/RegisteredUsers/VerifiedApplicationsByStateCR.js")
);
export const VerifiedApplicationsByStateDCR = lazyDefault(
  () => import("../components/Scn-Components/RegisteredUsers/VerifiedApplicationsByStateDCR.js")
);
export const VerifiedApplicationsByStateCJN = lazyDefault(
  () => import("../components/Scn-Components/RegisteredUsers/VerifiedApplicationsByStateCJN.js")
);
export const EnquiryLetterByStateDCR = lazyDefault(
  () => import("../components/Scn-WebComponents/EnquiryLetterByState/EnquiryLetterByStateDCR.jsx")
);
export const EnquiryLetterByStateCR = lazyDefault(
  () => import("../components/Scn-WebComponents/EnquiryLetterByState/EnquiryLetterByStateCR.jsx")
);
export const EnquiryLetterByStateCJN = lazyDefault(
  () => import("../components/Scn-WebComponents/EnquiryLetterByState/EnquiryLetterByStateCJN.jsx")
);
export const RecommendedApplicationsByState = lazyDefault(
  () => import("../components/Scn-Components/RegisteredUsers/RecommendedApplicationsByState.js")
);
export const RecommendedApplicationsByStateCR = lazyDefault(
  () => import("../components/Scn-Components/RegisteredUsers/RecommendedApplicationsByStateCR.js")
);
export const RecommendedApplicationsByStateDCR = lazyDefault(
  () => import("../components/Scn-Components/RegisteredUsers/RecommendedApplicationsByStateDCR.js")
);
export const RecommendedApplicationsByStateCJN = lazyDefault(
  () => import("../components/Scn-Components/RegisteredUsers/RecommendedApplicationsByStateCJN.js")
);
export const RecommendationLetterByState = lazyDefault(
  () =>
    import("../components/Scn-WebComponents/RecommendationLetter/RecommendationLetterByState.jsx")
);
export const RecommendationLetterByStateDCR = lazyDefault(
  () =>
    import("../components/Scn-WebComponents/RecommendationLetter/RecommendationLetterByStateDCR.jsx")
);
export const RecommendationLetterByStateCR = lazyDefault(
  () =>
    import("../components/Scn-WebComponents/RecommendationLetter/RecommendationLetterByStateCR.jsx")
);
export const RecommendationLetterByStateCJN = lazyDefault(
  () =>
    import("../components/Scn-WebComponents/RecommendationLetter/RecommendationLetterByStateCJN.jsx")
);
export const SingleRecommendation = lazyDefault(
  () => import("../components/Scn-WebComponents/SingleRecommendation/SingleRecommendation.jsx")
);
export const SingleSignedLetter = lazyDefault(
  () => import("../components/Scn-WebComponents/SingleSignedLetter/SingleSignedLetter.jsx")
);
export const Portal = lazyDefault(
  () => import("../components/Scn-Components/DocumentTypes/Portal")
);
export const AddLGA = lazyDefault(() => import("../components/Scn-Components/LGA/AddLGA"));
export const ChangeName = lazyDefault(
  () => import("../components/Scn-Components/ChangeOfName/UpdateNames")
);
export const PaymentStatusReport = lazyNamed(
  () => import("../components/Scn-Components/Reports/PaymentStatusReport.js"),
  "PaymentStatusReport"
);
